// src/locales/en/translation.ts
const en = {
  app: {
    title: "Cybersecurity CTF",
    play: "Play",
    admin: "Admin Panel",
    scoreboard: "Scoreboard",
    joinGame: "Join Game",
    joinTeam: "Join Team",
  },
  common: {
    welcomePlayer: "Welcome",
    chooseChallenge: "Choose a challenge and start playing.",
    gameCode: "Game Code:",
    teamPoints: "Team Points",
    search: "Search challenges...",
    question: "?",
    yes: "Yes",
    no: "No",
  },
  actions: {
    submit: "Submit",
    cancel: "Cancel",
    start: "Start",
    next: "Next",
    back: "Back",
    locked: "Locked",
    submitted: "Submitted",
  },
  play: {
    viewScoreboard: "Scoreboard",
    challengesTitle: "Challenges",
    filterByDifficulty: "Filter by difficulty",
    filterByCategory: "Filter by category",
    noChallenges: "No challenges available.",
    categories: "Categories",
    category: "Category",
    allcategories: "All Categories", //Please continue to work on Categories via Mapping from DB
    nochallenges: "No challenges found",
    points: "pts",
    duration: "min",
  },
  difficulty: {
    difficulty: "Difficulty",
    alldifficulties: "All Difficulties",
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
  },
  submitmodal: {
    //dev note: We may have duplicates now, which can be for diff functions. can be removed later or unified.
    submit: "Submit",
    launchChal: "Launch the Challenge",
    hints: "Hints",
    flag: "FLAG",
    revealHint: "Reveal Hint",
    revealHintText: "This will cost your team 15 points (if solved). Reveal?",
    attachment: "Attachment",
  },
  login: {
    adminLoginTitle: "Admin Login",
    username: "Username",
    usernamePlaceholder: "Username",
    password: "Password",
    passwordPlaceholder: "Password",
    login: "Log In",
    returnToPlayer: "Return to Player Login",
    loginFailedTitle: "Authentication Failed",
    invalidCredentials: "Login failed. Check username and password.",
    loginFailedGeneric: "...",
  },
  submissiontoast: {
    missingflag: "Missing Flag",
    plsFlag: "Please enter your flag",
    wrongFlag: "Wrong Flag",
    incorrectFlag: "Incorrect flag. Please try again.",
    correctFlag: "Correct!",
    hintRevealed: "Hint Revealed",
    hintRevealedText: "Read Carefully!",
    alreadyRevealed: "Already revealed",
    alreadyRevealedText: "Your team already used this hint",
    challengeCompleted: "Challenge already complete. Please Refresh",
    pointsBase: "+{{points}} points",
    pointsBonus: "(+{{bonus}} bonus)",
    pointsPenalty: "(-{{penalty}})",
    pointsTotal: "= +{{total}} points",
  },
  sidetoast: {
    welcomeChallenge: "🎉 Welcome Complete!",
    welcomeChallengeText:
      "You’ve successfully completed the introduction. All challenges are unlocked!",
    bonus: "🏆 Bonus Achieved!",
    firstSolve: "🏆 First team to solve this challenge! (+20 bonus)",
    secondSolve: "🥈 Second team to solve this challenge! (+15 bonus)",
    thirdSolve: "🥉 Third team to solve this challenge! (+10 bonus)",
  },
  scoreboard: {
    livescoreboard: "Live Scoreboard",
    refresh: "Refresh",
    backToPlay: "Back to Play",
    gamelabel: "Game",
    leaders: "Leaders",
    top3: "Top 3 teams by points",
    pts: "pts", // If hard to find in Arabic, please use the word points
    solveSprint: "Solve Sprint",
    solveText: "Solved challenges per team",
    points: "Points",
    pointspt: "points per team",
    allteams: "All Teams",
    livept: "Live points per team",
    noteams: "No teams yet",
    team: "Team",
    solves: "Solves",
    lastsolve: "Last Solve",
  },
  admin: {
    admindashboard: "Admin Dashboard",
    viewScoreboard: "View Scoreboard",
    logout: "Logout",
    createGame: "Create Game",
    code: "Code",
    createplholder: "e.g. CTF2025-ROUND2",
    codeHint: "Letters, numbers, dot, dash or underscore. No spaces.",
    maxteamsize: "Max Team Size",
    duration: "Duration(min)",
    status: "Status",
    lobby: "Lobby",
    active: "Active",
    ended: "Ended",
    selectTxt: "Select challenges",
    showing: "Showing:",
    allcategories: "All Categories",
    available2: "Available:",
    available1: "Available",
    selected: "Selected",
    create: "Create",
    teams: "Teams",
    teamsTxt: "Manage teams for the selected game",
    activeGame: "Active Game",
    selectGame: "Select a game…",
    noGames: "No games yet",
    genReset: "Generate / Reset",
    refresh: "Refresh",
    timer: "Timer",
    timerTxt: "Press Start to begin",
    start: "Start",
    end: "End",
    extend: "Extend (min)",
    numOfTeams: "Number of teams",
    team: "Team",
    joinLink: "Join Link",
    action: "Actions",
    teamTxt: "No teams yet. Generate to create teams.",
    selectTeamTxt: "Select a game first",
    noscore: "No scores yet",
    open: "Open",
    copy: "Copy",
    save: "Save",
    pts: "pts",
    add1Minute: "+1m",
    add5Minutes: "+5m",
    noPlayersYet: "This team has no players yet",
    gameControl: "Game control",
    gameControlTxt: "Start, extend or end the selected game",
    deleteGame: "Delete game",
    pinnedFirst: "Always first: players solve this to unlock the rest",
    endConfirmTitle: "End {{code}}?",
    endConfirmBody: "The game ends for every team right now and players can no longer submit flags. An ended game cannot be restarted.",
    endConfirmAccept: "End game",
    deleteConfirmTitle: "Delete {{code}}?",
    deleteConfirmBody: "This permanently deletes the game with all of its teams, players and scores. The challenges themselves are kept. This cannot be undone.",
    deleteConfirmBodyLive: "This game is still running. Deleting it stops it for every player now, and permanently removes its teams, players and scores. The challenges themselves are kept. This cannot be undone.",
    deleteConfirmAccept: "Delete game",
  },
  adminToasts: {
    gameCreated: 'Game "{{code}}" created with {{count}} challenge(s).',
    gameCodeError: "Game code is required.",
    challengeError: "Pick at least one challenge.",
    failedGames: "Failed to load games",
    failedChallenges: "Failed to load challenges",
    selectGame: "Select a game first",
    gameStarted: "Game Started",
    startFailed: "Start Failed",
    extendFailed: "Extend Failed",
    extendedBy: "Extended by {{seconds}}s.",
    gameEnded: "Game Ended",
    endFailed: "End failed",
    gameDeleted: 'Game "{{code}}" deleted.',
    createFailed: "Create failed",
    requestFailed: "Request failed",
    scoresRefreshed: "Scores Refreshed",
    failScoreboard: "Failed to load Scoreboard",
    teamsRefresh: "Teams Refreshed",
    failed: "Failed",
    teamEmpty: "Team name cannot be empty",
    updateFailed: "Update Failed",
    linkCopy: "Link copied to clipboard",
    success: "Success",
    error: "Error",
    savedTeamName: "Saved!",
    teamsRefreshed: "Teams refreshed",
    generatedTeams: "Generated {{count}} team(s).",
  },
  joinGame: {
    joinurTeam: "Join Your Team",
    joinholder: "Paste your invite link or team code",
    joinBtn: "Join",
    joinTip:
      "Tip: You can paste the full link, a /join/abcd123 path, or just the raw code.",
    joinError: "That doesn’t look like a valid invite link or code.",
  },
  joinTeam: {
    join: "Join ",
    joinTxt: "Enter your name to join the team and start playing!",
    yourName: "Your name",
    joinholder: "Enter your name",
    joinBtn: "Join",
    linkInvalid: "Link Invalid",
    linkInvalidTxt: "Could not find a valid game for the provided code.",
    goHome: "Go Home",
  },
  status: {
    lobby: "LOBBY",
    active: "ACTIVE",
    ended: "ENDED",
  },
  errors: {
    generic: "Something went wrong. Please try again.",
    GAME_CODE_INVALID:
      "That game code will not work. Use {{min}} to {{max}} characters: letters, numbers, dots, dashes or underscores, with no spaces.",
    GAME_CODE_TAKEN:
      "A game called \"{{code}}\" already exists. Pick a different code.",
    GAME_NOT_FOUND: "That game no longer exists. Refresh and pick another.",
    GAME_ALREADY_STARTED:
      "This game has already started, so its settings can no longer be changed.",
    MAX_TEAM_SIZE_INVALID: "Team size must be between {{min}} and {{max}}.",
    DURATION_INVALID:
      "Duration must be between {{minMinutes}} and {{maxMinutes}} minutes.",
    STATUS_INVALID: "That game status is not valid.",
    NO_CHALLENGES_SELECTED:
      "Add at least one challenge before creating the game.",
    UNKNOWN_CHALLENGES:
      "Some selected challenges no longer exist. Refresh the page and choose again.",
    EXTEND_INVALID: "Enter how many minutes to add.",
    TEAM_COUNT_INVALID: "Number of teams must be between {{min}} and {{max}}.",
    TEAM_NOT_FOUND: "That team is no longer part of this game.",
    TEAM_NAME_TOO_SHORT: "Name needs at least {{min}} characters.",
    TEAM_FULL: "This team is already full. Ask your organiser for another link.",
    PLAYER_NAME_TAKEN:
      "Someone on this team is already using that name. Try another.",
    JOIN_CODE_INVALID:
      "This invite link is not valid. Check it with your organiser.",
  },
  ui: {
    brandSub: "Awareness Challenge",
    skipToContent: "Skip to content",
    theme: "Colour theme",
    themeLight: "Light",
    themeDark: "Dark",
    switchLanguage: "Switch language",
    unknown: "Unknown",
    notFoundTitle: "Page not found",
    notFoundText:
      "That link does not lead anywhere. Check the address, or head back to the start.",
    noResults: "Nothing matches those filters",
    noResultsText:
      "Try a different category or difficulty, or clear the search.",
    clearFilters: "Clear filters",
    solvedCount: "{{solved}} of {{total}} solved",
    timeRemaining: "Time left",
    loadFailed: "Could not load challenges",
    retry: "Try again",
    solved: "Solved",
    selectAll: "Select all",
    live: "Live",
    reconnecting: "Reconnecting",
    clearAll: "Clear",
    dropHere: "Drag challenges here, or use the arrow on each one",
    nothingHere: "Nothing matches that search",
    lockedHint: "Finish the first challenge to unlock the rest.",
    progress: "Progress",
    attachments: "Attachments",
    noTeamsYet: "No teams yet",
    noTeamsYetText: "Generate teams to create join links for your players.",
    selectGameFirst: "Select a game",
    selectGameFirstText:
      "Choose an active game above to manage its teams and scores.",
  },
};

export default en;
